import { render, staticRenderFns } from "./SOP.vue?vue&type=template&id=7c4c236a"
import script from "./SOP.vue?vue&type=script&lang=js"
export * from "./SOP.vue?vue&type=script&lang=js"
import style0 from "./SOP.vue?vue&type=style&index=0&id=7c4c236a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports